<template>
<div class="chapter">
<div class="inner_page">
<p class="OT"><a id="page_v">Contents</a></p><a id="page_v">
</a><p class="TocSb1" id="for"><a id="page_v"></a><a href="#/xhtml/foreword#for"><i>Foreword</i> by Donald A. Hagner</a></p>
<p class="Toc" id="pre"><a href="#/xhtml/preface#pre">Preface</a></p>
<p class="Toc" id="abb"><a href="#/xhtml/abbreviations#abb">Abbreviations</a></p>
<p class="Toc1" id="ch-001"><a href="#/xhtml/chapter001#ch001">1.<span class="space">Good News to Gospels</span></a></p>
<p class="Toc1" id="ch-002"><span href="#/xhtml/chapter002#ch002" title="Link target outside of Sample">2.<span class="space">The Teaching of Jesus and the Story of Acts</span></span></p>
<p class="Toc1" id="ch-003"><span href="#/xhtml/chapter003#ch003" title="Link target outside of Sample">3.<span class="space">The Evidence of Mark, Matthew, and John</span></span></p>
<p class="Toc1" id="ch-004"><span href="#/xhtml/chapter004#ch004" title="Link target outside of Sample">4.<span class="space">The Evidence of Paul</span></span></p>
<p class="Toc1" id="ch-005"><span href="#/xhtml/chapter005#ch005" title="Link target outside of Sample">5.<span class="space">The Oral Tradition in the Gospels</span></span></p>
<p class="Toc1" id="ch-006"><span href="#/xhtml/chapter006#ch006" title="Link target outside of Sample">6.<span class="space">Two Examples of the Oral Tradition</span></span></p>
<p class="Toc1" id="ch-007"><a id="page_vi"></a><span href="#/xhtml/chapter007#ch007" title="Link target outside of Sample">7.<span class="space">The Extent of the Oral Tradition</span></span></p>
<p class="Toc1" id="ch-008"><span href="#/xhtml/chapter008#ch008" title="Link target outside of Sample">8.<span class="space">The Message of the First Christians</span></span></p>
<p class="Toc" id="bib"><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="Toc" id="idx-001"><span href="#/xhtml/index001#idx001" title="Link target outside of Sample">Author Index</span></p>
<p class="Toc" id="idx-002"><span href="#/xhtml/index002#idx002" title="Link target outside of Sample">Subject Index</span></p>
<p class="Toc" id="idx-003"><span href="#/xhtml/index003#idx003" title="Link target outside of Sample">Biblical References Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?883a309c